module.exports = __webpack_public_path__ + "img/max.df88e136.png";